import React, {PureComponent} from 'react';
import {
  Col,
  Row,
  Grid,
  Image,
} from 'react-bootstrap';
import Slider from 'react-slick';
import './HomePage.css';

class HomePage extends PureComponent {

  render() {

    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
      autoplaySpeed: 10000,
    };

    return (
      <div>
        <Grid>
            <Row>
              <Col sm={12} smOffset={0} className="HomePage">

                <Slider {...settings}>
                  <div className="HomePage-FeaturedImage">
                    <Image
                      src={`/gallery/santafe-2013-3.jpg`}
                      thumbnail
                    />
                    <event>
                      <piece>Giulio Cesare</piece>
                      <composer>George Fredric Handel</composer>
                      <location>Santa Fe Opera Apprentice Scenes</location>
                    </event>
                  </div>
                  <div className="HomePage-FeaturedImage">
                    <Image
                      src={`/gallery/santafe-2013-1.jpg`}
                      thumbnail
                    />
                    <event>
                      <piece>Carmen</piece>
                      <composer>Georges Bizet</composer>
                      <location>Santa Fe Opera Apprentice Scenes</location>
                    </event>
                  </div>
                  <div>
                    <Image
                      src={`/gallery/carmen-2.jpg`}
                      style={{'max-height': '427px'}}
                      thumbnail
                    />
                    <event>
                      <piece>Carmen</piece>
                      <composer>Georges Bizet</composer>
                      <location>El Paso Opera</location>
                    </event>
                  </div>
                  <div>
                    <Image
                      src={`/gallery/forte-8.jpg`}
                      thumbnail
                    />
                    <event>
                      <location>Forte Chicago</location>
                    </event>
                  </div>
                  <div className="HomePage-FeaturedImage">
                    <Image
                      src={`/gallery/santafe-2013-4.jpg`}
                      thumbnail
                    />
                    <event>
                      <piece>Carmen</piece>
                      <composer>Georges Bizet</composer>
                      <location>Santa Fe Opera Apprentice Scenes</location>
                    </event>
                  </div>
                  <div className="HomePage-FeaturedImage">
                    <Image
                      src={`/gallery/santafe-2013-12.jpg`}
                      thumbnail
                    />
                    <event>
                      <piece>Carmen</piece>
                      <composer>Georges Bizet</composer>
                      <location>Santa Fe Opera Apprentice Scenes</location>
                    </event>
                  </div>
                  <div>
                    <Image
                      src={`/gallery/carmen-10.jpg`}
                      style={{'max-height': '427px'}}
                      thumbnail
                    />
                    <event>
                      <piece>Carmen</piece>
                      <composer>Georges Bizet</composer>
                      <location>El Paso Opera</location>
                    </event>
                  </div>
                </Slider>

              </Col>
            </Row>
        </Grid>
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage.jsx